import { render } from "./PatientListBinah.vue?vue&type=template&id=5efe6ca0&scoped=true"
import script from "./PatientListBinah.vue?vue&type=script&lang=js"
export * from "./PatientListBinah.vue?vue&type=script&lang=js"

import "./PatientListBinah.vue?vue&type=style&index=0&id=5efe6ca0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efe6ca0"]])

export default __exports__